const GRADES = [
  { key: '-1', text: 'LKG', value: '-1' },
  { key: '0', text: 'UKG', value: '0' },
  { key: '1', text: 'G1', value: '1' },
  { key: '2', text: 'G2', value: '2' },
  { key: '3', text: 'G3', value: '3' },
  { key: '4', text: 'G4', value: '4' },
  { key: '5', text: 'G5', value: '5' },
  { key: '6', text: 'G6', value: '6' },
  { key: '7', text: 'G7', value: '7' },
  { key: '8', text: 'G8', value: '8' },
  { key: '9', text: 'G9', value: '9' },
  { key: '10', text: 'G10', value: '10' },
  { key: '11', text: 'G11', value: '11' },
  { key: '12', text: 'G12', value: '12' },
  { key: 'ALG1', text: 'ALG1', value: 'ALG1' },
  { key: 'ALG2', text: 'ALG2', value: 'ALG2' },
  { key: 'PCAL', text: 'PCAL', value: 'PCAL' },
  { key: 'GEO', text: 'GEO', value: 'GEO' },
  { key: 'CAL', text: 'CAL', value: 'CAL' },
];

const ALL_TIMEZONES = [
  {
    value: 'Etc/GMT+12',
    key: 'Etc/GMT+12',
    text: '(GMT-12:00) International Date Line West - Baker Island',
    region: 'NAM',
  },
  {
    value: 'Etc/GMT+11',
    key: 'Etc/GMT+11',
    text: '(GMT-11:00) Coordinated Universal Time-11 - Niue',
    region: 'APAC',
  },
  {
    value: 'America/Adak',
    key: 'America/Adak',
    text: '(GMT-10:00) Hawaii-Aleutian Time - Adak',
    region: 'NAM',
  }, // Closest to Honolulu
  {
    value: 'Pacific/Marquesas',
    key: 'Pacific/Marquesas',
    text: '(GMT-09:30) Marquesas Islands Time - Atuona',
    region: 'NAM',
  },
  {
    value: 'America/Anchorage',
    key: 'America/Anchorage',
    text: '(GMT-09:00) Alaska Time - Anchorage',
    region: 'NAM',
  },
  {
    value: 'America/Los_Angeles',
    key: 'America/Los_Angeles',
    text: '(GMT-08:00) Pacific Time - Los Angeles',
    region: 'NAM',
  },
  {
    value: 'America/Denver',
    key: 'America/Denver',
    text: '(GMT-07:00) Mountain Time - Denver',
    region: 'NAM',
  },
  {
    value: 'America/Chicago',
    key: 'America/Chicago',
    text: '(GMT-06:00) Central Time - Chicago',
    region: 'NAM',
  },
  {
    value: 'America/New_York',
    key: 'America/New_York',
    text: '(GMT-05:00) Eastern Time - New York',
    region: 'NAM',
  },
  {
    value: 'America/Halifax',
    key: 'America/Halifax',
    text: '(GMT-04:00) Atlantic Time - Halifax',
    region: 'NAM',
  },
  {
    value: 'America/St_Johns',
    key: 'America/St_Johns',
    text: "(GMT-03:30) Newfoundland Time - St. John's",
    region: 'NAM',
  },
  {
    value: 'America/Buenos_Aires',
    key: 'America/Buenos_Aires',
    text: '(GMT-03:00) Argentina Time - Buenos Aires',
    region: 'NAM',
  },
  {
    value: 'Atlantic/South_Georgia',
    key: 'Atlantic/South_Georgia',
    text: '(GMT-02:00) Coordinated Universal Time-02 - South Georgia',
    region: 'EMEA',
  },
  {
    value: 'Atlantic/Cape_Verde',
    key: 'Atlantic/Cape_Verde',
    text: '(GMT-01:00) Cape Verde Time - Praia',
    region: 'EMEA',
  },
  {
    value: 'Europe/London',
    key: 'Europe/London',
    text: '(GMT+00:00) Greenwich Mean Time - London',
    region: 'EMEA',
  },
  {
    value: 'Europe/Berlin',
    key: 'Europe/Berlin',
    text: '(GMT+01:00) Central European Time - Berlin',
    region: 'EMEA',
  },
  {
    value: 'Europe/Athens',
    key: 'Europe/Athens',
    text: '(GMT+02:00) Eastern European Time - Athens',
    region: 'EMEA',
  },
  {
    value: 'Europe/Moscow',
    key: 'Europe/Moscow',
    text: '(GMT+03:00) Moscow Standard Time - Moscow',
    region: 'EMEA',
  },
  {
    value: 'Asia/Tehran',
    key: 'Asia/Tehran',
    text: '(GMT+03:30) Iran Standard Time - Tehran',
    region: 'EMEA',
  },
  {
    value: 'Asia/Dubai',
    key: 'Asia/Dubai',
    text: '(GMT+04:00) Gulf Standard Time - Dubai',
    region: 'EMEA',
  },
  {
    value: 'Asia/Kabul',
    key: 'Asia/Kabul',
    text: '(GMT+04:30) Afghanistan Time - Kabul',
    region: 'ISC',
  },
  {
    value: 'Asia/Karachi',
    key: 'Asia/Karachi',
    text: '(GMT+05:00) Pakistan Standard Time - Karachi',
    region: 'ISC',
  },
  {
    value: 'Asia/Kolkata',
    key: 'Asia/Kolkata',
    text: '(GMT+05:30) Indian Standard Time - New Delhi',
    region: 'ISC',
  },
  {
    value: 'Asia/Kathmandu',
    key: 'Asia/Kathmandu',
    text: '(GMT+05:45) Nepal Time - Kathmandu',
    region: 'ISC',
  },
  {
    value: 'Asia/Dhaka',
    key: 'Asia/Dhaka',
    text: '(GMT+06:00) Bangladesh Standard Time - Dhaka',
    region: 'ISC',
  },
  {
    value: 'Asia/Yangon',
    key: 'Asia/Yangon',
    text: '(GMT+06:30) Myanmar Time - Yangon',
    region: 'APAC',
  },
  {
    value: 'Asia/Bangkok',
    key: 'Asia/Bangkok',
    text: '(GMT+07:00) Indochina Time - Bangkok',
    region: 'APAC',
  },
  {
    value: 'Asia/Shanghai',
    key: 'Asia/Shanghai',
    text: '(GMT+08:00) China Standard Time - Beijing',
    region: 'APAC',
  }, // Closest to Beijing
  {
    value: 'Australia/Eucla',
    key: 'Australia/Eucla',
    text: '(GMT+08:45) Australian Central Western Standard Time - Eucla',
    region: 'APAC',
  },
  {
    value: 'Asia/Tokyo',
    key: 'Asia/Tokyo',
    text: '(GMT+09:00) Japan Standard Time - Tokyo',
    region: 'APAC',
  },
  {
    value: 'Australia/Darwin',
    key: 'Australia/Darwin',
    text: '(GMT+09:30) Australian Central Standard Time - Darwin',
    region: 'APAC',
  },
  {
    value: 'Australia/Sydney',
    key: 'Australia/Sydney',
    text: '(GMT+10:00) Australian Eastern Standard Time - Sydney',
    region: 'APAC',
  },
  {
    value: 'Australia/Lord_Howe',
    key: 'Australia/Lord_Howe',
    text: '(GMT+10:30) Lord Howe Standard Time - Lord Howe Island',
    region: 'APAC',
  },
  {
    value: 'Pacific/Guadalcanal',
    key: 'Pacific/Guadalcanal',
    text: '(GMT+11:00) Solomon Islands Time - Honiara',
    region: 'APAC',
  }, // Closest to Honiara
  {
    value: 'Pacific/Auckland',
    key: 'Pacific/Auckland',
    text: '(GMT+12:00) New Zealand Standard Time - Wellington',
    region: 'APAC',
  }, // Closest to Wellington
  {
    value: 'Pacific/Chatham',
    key: 'Pacific/Chatham',
    text: '(GMT+12:45) Chatham Islands Standard Time - Chatham Islands',
    region: 'APAC',
  },
  {
    value: 'Pacific/Apia',
    key: 'Pacific/Apia',
    text: '(GMT+13:00) Phoenix Islands Time - Apia',
    region: 'APAC',
  }, // Closest to Apia
  {
    value: 'Pacific/Kiritimati',
    key: 'Pacific/Kiritimati',
    text: '(GMT+14:00) Line Islands Time - Kiritimati',
    region: 'APAC',
  },
];

const STATUS_COLOR = {
  'Trial Cancelled': 'red',
  'Qualified Lead': 'red',
  'Transfer Requested': 'red',
  'Trial Requested': 'grey',
  'Trial Confirmed': 'white',
  'Tutor Assigned': 'black',
  'Trial Done': 'white',
};

const US_COURSE_OPTIONS = [
  {
    label: 'Algebra I',
    value: 'Algebra I',
  },
  {
    label: 'Geometry',
    value: 'Geometry',
  },
  {
    label: 'Algebra II',
    value: 'Algebra II',
  },
  {
    label: 'Precalculus',
    value: 'Precalculus',
  },
  {
    label: 'Calculus',
    value: 'Calculus',
  },
  {
    label: 'Grade 7 Math',
    value: 'Grade 7 Math',
  },
  {
    label: 'Grade 8 Math',
    value: 'Grade 8 Math',
  },
];

const IND_BOARD_OPTIONS = [
  {
    label: 'CBSE',
    value: 'CBSE',
  },
  {
    label: 'ICSE',
    value: 'ICSE',
  },
  {
    label: 'IB',
    value: 'IB',
  },
  {
    label: 'IGCSE',
    value: 'IGCSE',
  },
  {
    label: 'State Board',
    value: 'State Board',
  },
  {
    label: 'Other',
    value: 'Other',
  },
];

// Course names as constants for easier maintenance
const COURSE_NAMES = {
  ALGEBRA_I: 'Algebra I',
  GEOMETRY: 'Geometry',
  ALGEBRA_II: 'Algebra II',
  PRECALCULUS: 'Precalculus',
  CALCULUS: 'Calculus',
  GRADE_7_MATH: 'Grade 7 Math',
  GRADE_8_MATH: 'Grade 8 Math',
};

// Grade-to-course mapping based on school board standards
const GRADE_TO_COURSES_MAP = {
  7: [COURSE_NAMES.GRADE_7_MATH, COURSE_NAMES.ALGEBRA_I, COURSE_NAMES.GEOMETRY],
  8: [
    COURSE_NAMES.GRADE_8_MATH,
    COURSE_NAMES.ALGEBRA_I,
    COURSE_NAMES.GEOMETRY,
    COURSE_NAMES.ALGEBRA_II,
  ],
  9: [
    COURSE_NAMES.ALGEBRA_I,
    COURSE_NAMES.GEOMETRY,
    COURSE_NAMES.ALGEBRA_II,
    COURSE_NAMES.PRECALCULUS,
  ],
  10: [
    COURSE_NAMES.GEOMETRY,
    COURSE_NAMES.ALGEBRA_II,
    COURSE_NAMES.PRECALCULUS,
    COURSE_NAMES.CALCULUS,
  ],
  11: [COURSE_NAMES.ALGEBRA_II, COURSE_NAMES.PRECALCULUS, COURSE_NAMES.CALCULUS],
  12: [COURSE_NAMES.ALGEBRA_II, COURSE_NAMES.PRECALCULUS, COURSE_NAMES.CALCULUS],
};

const getUSCourseOptionsByGrade = grade => {
  const gradeNumber = parseInt(grade, 10);
  const availableCourseValues =
    GRADE_TO_COURSES_MAP[gradeNumber] || US_COURSE_OPTIONS.map(option => option.value);

  // Filter US_COURSE_OPTIONS to only include courses available for this grade
  return US_COURSE_OPTIONS.filter(course => availableCourseValues.includes(course.value));
};

// CNA Question types
const CNA_QUESTION_TYPES = {
  CARD: 'card',
  CHECKBOX: 'checkbox',
  DROPDOWN: 'dropdown',
};

// CNA Question text constants
const CNA_QUESTIONS = {
  MATH_PERFORMANCE: {
    HEADING: "How's your child doing in math?",
    SUB_HEADING: 'Select one option',
  },
  LEARNING_GOALS: {
    HEADING: 'What would you like your child to work on?',
    SUB_HEADING: 'Select all that apply',
  },
  SCHOOL_BOARD_COURSE: {
    HEADING: 'Which school board course would you like your child to focus on?',
    SUB_HEADING: 'Select one option',
  },
  SCHOOL_BOARD: {
    HEADING: "Please select your child's school board",
    SUB_HEADING: 'Select one option',
  },
};

// Performance level options
const PERFORMANCE_LEVELS = [
  {
    heading: 'Needs Support',
    value: 'Finding current math topics difficult to grasp',
  },
  {
    heading: 'Keeping Up',
    value: 'Meeting grade-level expectations with room to grow',
  },
  {
    heading: 'Excelling',
    value: 'Seeking more rigorous and challenging material',
  },
];

// Learning goal options
const LEARNING_GOALS = [
  'Build fundamentals or address gaps',
  'Keep up with homework and school exams',
  'Prepare for a contest or external test',
  'Qualify for accelerated / honors / gifted programs',
  'Enhance calculation speed and accuracy',
  'Make math relatable and enjoyable',
  'Tackle advanced concepts and problems',
];

const getCNAData = (region, grade) => {
  const baseData = {
    1: {
      heading: CNA_QUESTIONS.MATH_PERFORMANCE.HEADING,
      subHeading: CNA_QUESTIONS.MATH_PERFORMANCE.SUB_HEADING,
      options: PERFORMANCE_LEVELS,
      type: CNA_QUESTION_TYPES.CARD,
    },
    2: {
      heading: CNA_QUESTIONS.LEARNING_GOALS.HEADING,
      subHeading: CNA_QUESTIONS.LEARNING_GOALS.SUB_HEADING,
      options: LEARNING_GOALS,
      type: CNA_QUESTION_TYPES.CHECKBOX,
    },
  };

  // Add US course question for NAM region
  if (region === 'NAM' && grade > 6) {
    const usCourseOptions = getUSCourseOptionsByGrade(grade);
    baseData[3] = {
      heading: CNA_QUESTIONS.SCHOOL_BOARD_COURSE.HEADING,
      subHeading: CNA_QUESTIONS.SCHOOL_BOARD_COURSE.SUB_HEADING,
      options: usCourseOptions,
      type: CNA_QUESTION_TYPES.DROPDOWN,
    };
  } else if (region === 'INDIA') {
    // Add Indian board options for INDIA region
    const indBoardOptions = IND_BOARD_OPTIONS;
    baseData[3] = {
      heading: CNA_QUESTIONS.SCHOOL_BOARD.HEADING,
      subHeading: CNA_QUESTIONS.SCHOOL_BOARD.SUB_HEADING,
      options: indBoardOptions,
      type: CNA_QUESTION_TYPES.DROPDOWN,
    };
  }

  return baseData;
};

const CNA_DATA = {
  1: {
    heading: CNA_QUESTIONS.MATH_PERFORMANCE.HEADING,
    subHeading: CNA_QUESTIONS.MATH_PERFORMANCE.SUB_HEADING,
    options: PERFORMANCE_LEVELS,
    type: CNA_QUESTION_TYPES.CARD,
  },
  2: {
    heading: CNA_QUESTIONS.LEARNING_GOALS.HEADING,
    subHeading: CNA_QUESTIONS.LEARNING_GOALS.SUB_HEADING,
    options: LEARNING_GOALS,
    type: CNA_QUESTION_TYPES.CHECKBOX,
  },
};

const MODAL_NAMES = {
  editCustomerNeeds: 'editCustomerNeeds',
  addCustomerNeeds: 'addCustomerNeeds',
  cancelTrial: 'cancelTrial',
  assignSlot: 'assignSlot',
  rescheduleSlot: 'rescheduleSlot',
  rescheduleSlotSameTutor: 'rescheduleSlotSameTutor',
  rescheduleSlotDifferentTutor: 'rescheduleSlotDifferentTutor',
};

const CANCELLATION_REASONS = [
  {
    key: "Don't have time right now",
    value: "Don't have time right now",
    text: "Don't have time right now",
  },
  {
    key: "Child doesn't need help anymore",
    value: "Child doesn't need help anymore",
    text: "Child doesn't need help anymore",
  },
  {
    key: 'Found another tutoring service/ already enrolled elsewhere',
    value: 'Found another tutoring service/ already enrolled elsewhere',
    text: 'Found another tutoring service/ already enrolled elsewhere',
  },
  {
    key: 'Prefer in-person tutoring',
    value: 'Prefer in-person tutoring',
    text: 'Prefer in-person tutoring',
  },
  {
    key: 'Technical concerns (poor internet, device issues, platform difficulties)',
    value: 'Technical concerns (poor internet, device issues, platform difficulties)',
    text: 'Technical concerns (poor internet, device issues, platform difficulties)',
  },
  {
    key: 'Child is too young',
    value: 'Child is too young',
    text: 'Child is too young',
  },
  {
    key: 'Child is involved in other activities',
    value: 'Child is involved in other activities',
    text: 'Child is involved in other activities',
  },
  {
    key: 'Relocated to another country',
    value: 'Relocated to another country',
    text: 'Relocated to another country',
  },
  {
    key: 'Changed mind about online tutoring',
    value: 'Changed mind about online tutoring',
    text: 'Changed mind about online tutoring',
  },
  {
    key: 'Just wanted trial/ details only',
    value: 'Just wanted trial/ details only',
    text: 'Just wanted trial/ details only',
  },
  {
    key: 'Multiple attempts non-responsive/ disconnected after hearing',
    value: 'Multiple attempts non-responsive/ disconnected after hearing',
    text: 'Multiple attempts non-responsive/ disconnected after hearing',
  },
  {
    key: "Different expectations than what's offered",
    value: "Different expectations than what's offered",
    text: "Different expectations than what's offered",
  },
  {
    key: 'Other',
    value: 'Other',
    text: 'Other',
  },
];

const isValidEmail = email => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export {
  GRADES,
  ALL_TIMEZONES,
  STATUS_COLOR,
  CNA_DATA,
  getCNAData,
  US_COURSE_OPTIONS,
  getUSCourseOptionsByGrade,
  COURSE_NAMES,
  GRADE_TO_COURSES_MAP,
  CNA_QUESTION_TYPES,
  CNA_QUESTIONS,
  PERFORMANCE_LEVELS,
  LEARNING_GOALS,
  MODAL_NAMES,
  CANCELLATION_REASONS,
  isValidEmail,
};
